import { BaseService } from "./BaseService";

export class NotificationService extends BaseService {

    constructor(url) {
        
        super(url);
    }

    async getNotifications(params) {
        return this.get(params)
    }

}